import { Skeleton } from "./Skeleton"

export function LeaderboardRowSkeleton({ showVolume = true }: { showVolume?: boolean }) {
	return (
		<output
			aria-busy="true"
			className="flex items-center gap-2.5 rounded-2xl border border-transparent bg-bg-card px-3 py-2.5 shadow-sm ring-1 ring-border-subtle lg:gap-5 lg:px-6 lg:py-4 dark:bg-bg-secondary/40"
		>
			<span className="sr-only">Loading leaderboard entry…</span>
			{/* Avatar - SimpleAvatar size="md" (size-10) with variant="square" uses rounded-md, lg:size-11 override */}
			<Skeleton className="size-10 shrink-0 rounded-md lg:size-11" />
			{/* Name + handle - matches text-base/text-lg line-heights */}
			<div className="min-w-0 flex-1">
				<Skeleton className="h-6 w-24 rounded lg:h-7 lg:w-32" />
				<Skeleton className="mt-0.5 h-5 w-16 rounded lg:h-5 lg:w-20" />
			</div>
			{/* Mindshare - matches text-sm/text-base line-heights */}
			<div className="flex shrink-0 flex-col items-center justify-center text-center">
				<Skeleton className="h-5 w-12 rounded lg:h-6 lg:w-14" />
			</div>
			{/* Probability + volume - matches text-sm/text-lg line-heights, volume is text-[10px]/lg:text-xs */}
			<div className="flex w-14 shrink-0 flex-col items-center justify-center border-border-highlight border-l pl-3 text-center lg:w-20 lg:pl-4">
				<Skeleton className="h-5 w-10 rounded lg:h-7 lg:w-12" />
				{showVolume && <Skeleton className="mt-0.5 h-4 w-12 rounded lg:h-5 lg:w-14" />}
			</div>
		</output>
	)
}
